<div class="upload-field">
  <div #buttonsRightTemplate>
    <coin-v2-button
      [type]="'primary'"
      [icon]="'upload'"
      [iconPos]="'right'"
      [text]="'Add Transfer List Entry'"
      (click)="openCreateTransferListEntryPopup()"></coin-v2-button>
  </div>
</div>

<importer-simple-table
  [header]="selectedTableHeaders"
  [service]="transferListService"
  [serverPaginated]="true"
  [serverside]="true"
  [presetQueryParams]="queryParameters$ | async"
  [updaterIntervalInMs]="updaterIntervalInMs">
  <ng-template
    #columns
    let-item>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <i
              class="edit-button material-icons"
              (click)="openUpdateTransferListEntryPopup(item)">
              edit
            </i>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <i
              class="edit-button material-icons"
              (click)="openDeleteTransferListEntryPopup(item)">
              delete
            </i>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.Gid }}
            </p>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.SourceOrgCode }}
            </p>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.TargetOrgCode }}
            </p>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.Origin }}
            </p>
          </div>
        }
      </div>

      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.CreatedAt | date: 'MMM d, y (HH:mm)' : 'UTC' }}
            </p>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.CreatedByGid }}
            </p>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.LastModifiedAt | date: 'MMM d, y (HH:mm)' : 'UTC' }}
            </p>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.LastModifiedByGid }}
            </p>
          </div>
        }
      </div>
    </ng-container>
  </ng-template>
</importer-simple-table>
